import { render, staticRenderFns } from "./EditableTextarea.vue?vue&type=template&id=4ec57ba6&scoped=true"
import script from "./EditableTextarea.vue?vue&type=script&lang=js"
export * from "./EditableTextarea.vue?vue&type=script&lang=js"
import style0 from "./EditableTextarea.vue?vue&type=style&index=0&id=4ec57ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec57ba6",
  null
  
)

export default component.exports